import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';


export const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: 'rgba(0, 0, 0, 0.12) !important',
  }));